import { useState } from "react";

import {
  arrowDownWard,
  command,
  notification,
  profilePic,
  programming_arrow,
  togglePic,
  FipayMobile,
  HamburgerIcon,
  x_alt,
} from "../../../../public/assets";
import {
  PaymentLinkContainer,
  PaymentLinkSubtitle,
  IntegrationSupportCon,
  ApiDoc,
  TestMode,
  DividerOne,
  DividerTwo,
  NotificationBar,
  NameContainer,
  ProfilePicCon,
  NameSubtitle,
  NameTag,
  EmailTag,
  ArrowDownImg,
  MobileMenu,
  MobileComponents,
  HamburgerIconWrapper,
  DropdownContent,
  DropdownAccContainer,
} from "./Navbar.styles";
import PaymentLinkSidebar from "../Sidebar";
import { Link } from "react-router-dom";
import DropDownAccount from "./account";
import { useSelector } from "react-redux";
import { useQuery } from "@apollo/client";
import { RootState } from "../../../store/rootReducer";
import { GET_USER_BY_ID } from "../../../graphql/queries/userManagement";

interface DropdownContentProps {
  isOpen: boolean;
}

const PaymentLinkNavbar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showAcountDropdown, setShowAccountDropDown] = useState(false);

  const toggleAccountDropDown = () => {
    setShowAccountDropDown(!showAcountDropdown);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleKeyPress = (event: KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      toggleDropdown();
    }
  };

  const id = useSelector((state: RootState) => state.user?.user.id);

  const {
    loading: queryLoading,
    error: queryError,
    data: queryData,
  } = useQuery(GET_USER_BY_ID);

  const userDetails = queryData?.getUserById;

  return (
    <PaymentLinkContainer>
      <PaymentLinkSubtitle>
        <MobileMenu>
          <HamburgerIconWrapper onClick={toggleDropdown}>
            <img src="/assets/svg/menu.svg" alt="HamburgerIcon" />
          </HamburgerIconWrapper>
          {isDropdownOpen && (
            <DropdownContent isOpen={isDropdownOpen}>
              <PaymentLinkSidebar
                closeButton={{
                  icon: "/assets/svg/x-alt.svg",
                  onClick: toggleDropdown,
                }}
              />
            </DropdownContent>
          )}
          <Link to="/">
            {" "}
            <img src="/assets/icons/fipay-mobile.svg" alt="fipaylogo" />
          </Link>
        </MobileMenu>
        <IntegrationSupportCon>
          <img src="/assets/programming-arrow.png" alt="programming-arrow" />
          <span>Integration Support</span>
        </IntegrationSupportCon>
        <ApiDoc>
          <img src="/assets/command.png" alt="command" />{" "}
          <span>API Documentation</span>
        </ApiDoc>
        <TestMode>
          <img src="/assets/Component 4.png" alt="toogle-pic" />
          <span>Test Mode</span>
        </TestMode>

        <DividerOne></DividerOne>
        <MobileComponents>
          <NotificationBar>
            <img src="/assets/svg/notification.svg" alt="notification-icon" />
          </NotificationBar>
          <DividerTwo></DividerTwo>
          <NameContainer>
            <ProfilePicCon>
              <img src="/assets/Ellipse 1.png" alt="profile-pic" />
            </ProfilePicCon>
            <NameSubtitle>
              <NameTag>
                {userDetails?.fullName ? userDetails.fullName : ""}
              </NameTag>
              <EmailTag>{userDetails?.email ? userDetails.email : ""}</EmailTag>
            </NameSubtitle>
          </NameContainer>
          <DropdownAccContainer>
            {showAcountDropdown && (
              <DropDownAccount
                setShowDiv={setShowAccountDropDown}
                showDiv={showAcountDropdown}
              />
            )}
          </DropdownAccContainer>
          <ArrowDownImg onClick={toggleAccountDropDown}>
            <img src="/assets/Vector.png" alt="arro-downward" />
          </ArrowDownImg>
        </MobileComponents>
      </PaymentLinkSubtitle>
    </PaymentLinkContainer>
  );
};

export default PaymentLinkNavbar;
